import { IconProps } from '@/types/icon';

export function IconeMascaras(props: IconProps) {
  const { size } = props;
  return (
    <svg
      viewBox="0 0 27 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      {...props}
    >
      <path
        d="M22.14 7.30417C22.794 7.30417 23.3242 6.77398 23.3242 6.11996C23.3242 5.46594 22.794 4.93575 22.14 4.93575C21.486 4.93575 20.9558 5.46594 20.9558 6.11996C20.9558 6.77398 21.486 7.30417 22.14 7.30417Z"
        fill="white"
      />
      <path
        d="M17.4032 7.30417C18.0572 7.30417 18.5874 6.77398 18.5874 6.11996C18.5874 5.46594 18.0572 4.93575 17.4032 4.93575C16.7491 4.93575 16.219 5.46594 16.219 6.11996C16.219 6.77398 16.7491 7.30417 17.4032 7.30417Z"
        fill="white"
      />
      <path
        d="M19.7597 9.08049C18.1255 9.08049 16.7992 10.0752 16.7992 11.3068H22.7203C22.7203 10.0752 21.394 9.08049 19.7597 9.08049Z"
        fill="white"
      />
      <path
        d="M0.824219 17.37C0.824219 21.2897 4.00975 24.4752 7.92948 24.4752C11.8492 24.4752 15.0347 21.2897 15.0347 17.37V9.08049H0.824219V17.37ZM3.19264 11.4489H12.6663V17.37C12.6663 19.9871 10.5466 22.1068 7.92948 22.1068C5.31238 22.1068 3.19264 19.9871 3.19264 17.37V11.4489Z"
        fill="white"
      />
      <path
        d="M12.6663 0.791016V7.30417H15.0347V3.15944H24.5084V9.08049C24.5084 11.6976 22.3887 13.8173 19.7716 13.8173C18.6466 13.8173 17.6282 13.4029 16.8111 12.7515V15.5344C17.7111 15.9489 18.7176 16.1858 19.7716 16.1858C23.6913 16.1858 26.8769 13.0002 26.8769 9.08049V0.791016H12.6663Z"
        fill="white"
      />
      <path
        d="M5.56106 15.5936C6.21508 15.5936 6.74527 15.0635 6.74527 14.4094C6.74527 13.7554 6.21508 13.2252 5.56106 13.2252C4.90704 13.2252 4.37685 13.7554 4.37685 14.4094C4.37685 15.0635 4.90704 15.5936 5.56106 15.5936Z"
        fill="white"
      />
      <path
        d="M10.2979 15.5936C10.9519 15.5936 11.4821 15.0635 11.4821 14.4094C11.4821 13.7554 10.9519 13.2252 10.2979 13.2252C9.64388 13.2252 9.11369 13.7554 9.11369 14.4094C9.11369 15.0635 9.64388 15.5936 10.2979 15.5936Z"
        fill="white"
      />
      <path
        d="M7.92948 19.5963C9.56369 19.5963 10.89 18.6015 10.89 17.37H4.96896C4.96896 18.6015 6.29527 19.5963 7.92948 19.5963Z"
        fill="white"
      />
    </svg>
  );
}
